module.exports = {"title":"Уверенность в каждом километре","description":"Как организован контроль качества бензина в производственном цикле НК «Роснефть» — от нефтеперерабатывающего завода до заправочного пистолета — рассказывает интерактивный проект «Рамблер/Авто»","image":"http://rosneft.rambler.ru/img/share2.jpg","url":"http://rosneft.rambler.ru/","fbappid":396959934055666,"trackingID":"UA-105301080-24","clientTrackingID":"","top100":0,"clientTop100":0,"yaMetrika":0}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 11
// module chunks = 0